export interface DocumentoResumen {
  nroInterno: number;
  anio: number;
  numero: number;
  tipo: string;
  fecha: string | null;
  visto: string;
  observaciones: string;
}

export interface Documento extends DocumentoResumen {
  expediente: { prefijo: string; numero: string; anio: number | null; extension: string };
  texto: string;
}

export interface ResultadoBusqueda {
  total: number;
  pagina: number;
  porPagina: number;
  data: DocumentoResumen[];
}

export interface Filtros {
  anio?: number;
  mes?: number;
  tipo?: string;
  numero?: number;
  q?: string;
  exacto?: boolean;
  pagina?: number;
}

async function pedir<T>(url: string, signal?: AbortSignal): Promise<T> {
  const r = await fetch(url, { signal, headers: { Accept: 'application/json' } });
  if (!r.ok) {
    let msg = `Error ${r.status}`;
    try {
      msg = ((await r.json()) as { error?: string }).error ?? msg;
    } catch {
      /* respuesta sin JSON */
    }
    throw new Error(msg);
  }
  return r.json() as Promise<T>;
}

export function filtrosAParams(f: Filtros): URLSearchParams {
  const p = new URLSearchParams();
  if (f.anio) p.set('anio', String(f.anio));
  if (f.mes) p.set('mes', String(f.mes));
  if (f.tipo) p.set('tipo', f.tipo);
  if (f.numero) p.set('numero', String(f.numero));
  if (f.q?.trim()) p.set('q', f.q.trim());
  if (f.exacto) p.set('exacto', 'true');
  if (f.pagina && f.pagina > 1) p.set('pagina', String(f.pagina));
  return p;
}

export function paramsAFiltros(p: URLSearchParams): Filtros {
  const num = (k: string) => {
    const n = Number(p.get(k));
    return Number.isInteger(n) && n > 0 ? n : undefined;
  };
  return {
    anio: num('anio'),
    mes: num('mes'),
    tipo: p.get('tipo') || undefined,
    numero: num('numero'),
    q: p.get('q') || undefined,
    exacto: p.get('exacto') === 'true',
    pagina: num('pagina'),
  };
}

export const api = {
  anios: (s?: AbortSignal) => pedir<{ data: number[] }>('/api/anios', s).then((r) => r.data),
  tipos: (s?: AbortSignal) => pedir<{ data: string[] }>('/api/tipos', s).then((r) => r.data),
  buscar: (f: Filtros, s?: AbortSignal) =>
    pedir<ResultadoBusqueda>(`/api/documentos?${filtrosAParams(f)}`, s),
  documento: (nro: number, s?: AbortSignal) => pedir<Documento>(`/api/documentos/${nro}`, s),
  urlPdf: (nro: number) => `/api/documentos/${nro}/pdf`,
};
